import React from "react";
import { withTranslation } from "react-i18next";
import Compressor from "../imagesHelper/compressor";

class UploadImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isReady: false,
            src: "",
            uploaded: false
        };

        this.on = {
            change: (event) => {
                this.setState({ isLoading: true });
                const file = event.target.files[0];
                if (file) {
                    const self = this;
                    new Compressor(file, {
                        quality: 1,
                        maxWidth: 500,
                        maxHeight: 500,
                        mineType: "auto",
                        convertSize: 5000000,
                        success(result) {
                            const reader = new FileReader();
                            reader.readAsDataURL(result);
                            reader.onload = (e) => {
                                const fileData = e.target.result.split(",")[1];
                                self.setState({ isReady: true, uploaded: true }, () => {
                                    if (typeof self.props.onChange === "function") {
                                        self.props.onChange(fileData, e.target.result);
                                    }
                                });
                            };
                            reader.onerror = (error) => {
                                console.error(error);
                            };
                        }
                    });
                }
            },
            click: () => {
                const upload = document.getElementById("upload-photo");
                if (upload) upload.click();
            }
        };
    }

    render() {
        const { t } = this.props;
        const { isReady, uploaded, src } = this.state;

        return (
            <>
                <button
                    className={`inline-flex border-0 py-2 px-6 focus:outline-none rounded text-lg ml-4 mr-4 ${
                        uploaded ? "bg-gray-200 hover:bg-gray-400 text-black" : "bg-blue-900 hover:bg-blue-600 text-white"
                    }`}
                    onClick={this.on.click}
                >
                    {isReady ? t("btn_retake_photo") : t("btn_upload_photo")}
                </button>
                {src && <img style={{ margin: "auto", width: "20px", height: "200px" }} src={src} alt="Preview" />}
                <input onChange={this.on.change} hidden id="upload-photo" accept="image/*;capture=camera" type="file" />
            </>

        );
    }
}

export default withTranslation()(UploadImage);
